<div class="carrossel-content" >
  <img [src]="imagens[indexImagemAtiva]" alt="">
</div>

<div class="botoes-controle">
  <button *ngFor="let imagem of imagens; index as i" [class.ativo]="i === indexImagemAtiva" (click)="pararTimer(); ativarImagem(i)"></button>
</div>
